module.exports = __webpack_public_path__ + "img/17.8afab6c9.jpg";